/** @jsxImportSource @emotion/react */
import alert from "../../../../images/forms/alert.png"
import { useTheme } from "../../hooks/useTheme"

type Props = {
  message?: string | string[]
}

export const FormFieldError: React.FC<Props> = ({ message }) => {
  const { colors, fonts, gaps } = useTheme()

  return (
    <div
      css={{
        alignItems: "bottom",
        color: colors.danger[300],
        display: "grid",
        columnGap: gaps[3],
        fontFamily: fonts.lato.name,
        fontSize: 13,
        fontWeight: fonts.lato.weight[400],
        gridTemplateColumns: "auto 1fr",
        height: 24 + gaps[3],
        lineHeight: "24px",
        paddingTop: gaps[3]
      }}
    >
      {message != null && (
        <>
          <img alt="Alert" height={18} src={alert} width={20} />
          <div>{message}</div>
        </>
      )}
    </div>
  )
}
